import apiService from './apiService';

const PREFIX = '/iti/maintenance';

async function request(promise) {
  const res = await promise;
  if (!res.success) {
    throw new Error(res.message || 'Erreur API');
  }
  return res;
}

const csv = (values) => (Array.isArray(values) && values.length ? values.join(',') : undefined);

const itiMaintenanceService = {
  async listSites(filters = {}) {
    const res = await request(apiService.get(`${PREFIX}/sites`, {
      search: filters.search || undefined,
      server: csv(filters.servers),
      plugin: csv(filters.plugins),
      tag: csv(filters.tags),
      has_email: filters.hasEmail === true ? '1' : filters.hasEmail === false ? '0' : undefined,
      has_client: filters.hasClient === true ? '1' : filters.hasClient === false ? '0' : undefined,
    }));
    return {
      items: res.data?.items ?? [],
      total: res.data?.total ?? 0,
    };
  },

  async facets() {
    const res = await request(apiService.get(`${PREFIX}/facets`));
    return {
      servers: res.data?.servers ?? [],
      tags: res.data?.tags ?? [],
      plugins: res.data?.plugins ?? [],
    };
  },

  async listTemplates() {
    const res = await request(apiService.get(`${PREFIX}/templates`));
    return res.data?.items ?? [];
  },

  async saveTemplate(payload, id = null) {
    const res = id
      ? await request(apiService.put(`${PREFIX}/templates/${id}`, payload))
      : await request(apiService.post(`${PREFIX}/templates`, payload));
    return res.data?.template;
  },

  async deleteTemplate(id) {
    await request(apiService.delete(`${PREFIX}/templates/${id}`));
  },

  async preview(payload) {
    const res = await request(apiService.post(`${PREFIX}/preview`, payload));
    return res.data;
  },

  async send(payload) {
    const res = await request(apiService.post(`${PREFIX}/send`, payload));
    return res.data;
  },

  async sendOne(payload) {
    const res = await request(apiService.post(`${PREFIX}/send-one`, payload));
    return res.data;
  },

  async recordEnvoi(payload) {
    const res = await request(apiService.post(`${PREFIX}/envois`, payload));
    return res.data;
  },

  async refreshEmails(hebergementIds) {
    const res = await request(apiService.post(`${PREFIX}/emails/refresh`, {
      hebergement_ids: hebergementIds,
    }));
    return res.data?.items ?? [];
  },

  async updateSiteEmail(id, email) {
    const res = await request(apiService.put(`${PREFIX}/sites/${id}/email`, { email }));
    return res.data?.site;
  },

  async getEnvoi(id) {
    const res = await request(apiService.get(`${PREFIX}/envois/${id}`));
    return res.data;
  },

  async resendErrors(id, payload = {}) {
    const res = await request(apiService.post(`${PREFIX}/envois/${id}/resend-errors`, payload));
    return res.data;
  },

  async listEnvois(page = 1, limit = 20) {
    const res = await request(apiService.get(`${PREFIX}/envois`, { page, limit }));
    return {
      items: res.data?.items ?? [],
      pagination: res.pagination ?? { page, limit, total: 0 },
    };
  },
};

export default itiMaintenanceService;
